import { useQueryWithUserId } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

interface IUseBidQtyQueryParams {
  assetId: string;
  enabled?: boolean;
}

/**
 * This is to track the download bid book query key in react query cache.
 */
const BIDS_QUANTITY_KEY = 'bids-qty-key';

/**
 * Fetches the list of quantities supported by this bid.
 * Note: Identify why we have a separate hook for web and mobile. cc @Renji.
 */
export const useBidGetQuantityQuery = ({
  assetId,
  enabled = true,
}: IUseBidQtyQueryParams) => {
  const { data, isError, error, isLoading, isPending, isFetching, refetch } =
    useQueryWithUserId({
      queryKey: [BIDS_QUANTITY_KEY, assetId],
      enabled: enabled && !!assetId,
      retry: false,
      queryFn: () => BIDS_API.fetchBidsQuantity(assetId),
    });

  return {
    data,
    isError,
    error,
    isPending,
    isLoading,
    isFetching,
    refetch,
  };
};
